<!--<div class="header border-top-radius">-->
<!--  <div class="try-now-container">-->
<!--    <h2 class="try-now-description">Bezpieczeństwo</h2>-->
<!--  </div>-->
<!--</div>-->

<div class="row demo border-bottom-radius" style="background: var(--background)">
  <div class="col-sm-12 col-xl-5 demo-data margin-right-if-scaled margins">
    <div style="display: flex; flex-direction: row; align-items: center">
      <div style="">
<!--            <mat-icon class="icons"-->
<!--              style="background-color: rgba(33, 150, 243, 0.15); color: #01a8a5;">-->
            <mat-icon class="icons noselect"
              style="background-color: rgba(139, 72, 222, 0.15); color: #8b48de;">
              equalizer
            </mat-icon>
          </div>
      <h1 class="demo-title" style="margin-bottom: 0; margin-left: 12px;">{{ 'title' | language:'data warehouses':languageService.selectedLanguage }}</h1>
    </div>

    <div class="demo-data" style="padding-top: 0;">
      <h3 class="demo-description">
        <div>{{ 'first paragraph' | language:'data warehouses':languageService.selectedLanguage }}
        </div>
      </h3>
      <h3 class="demo-description">
        <div>{{ 'second paragraph' | language:'data warehouses':languageService.selectedLanguage }}</div>
      </h3>
      <h3 class="demo-description">
        <div>{{ 'third paragraph' | language:'data warehouses':languageService.selectedLanguage }}</div>
      </h3>
    </div>
    <div class="demo-buttons">
      <a routerLink="/kontakt" class="not-underline"><button mat-button class="demo-button"><b>{{ 'first button' | language:'data warehouses':languageService.selectedLanguage }}</b></button></a>
      <a routerLink="/" class="not-underline"><button mat-button class="demo-button-2"><b>{{ 'second button' | language:'data warehouses':languageService.selectedLanguage }}</b></button></a>
    </div>
  </div>
  <div class="col-sm-12 col-xl-5 demo-movie noselect">
    <img class="image-scaler" src="./assets/vector/sibrica-data-warehouse-project.jpg" [alt]="'image alt' | language:'data warehouses':languageService.selectedLanguage" width="500" height="282.608695652"
         style="max-width: 90vw; max-height: calc(90vw / 500 * 333.33); border-radius: 16px;">
    <!--    <img class="image-scaler" width="500" style="max-width: 90vw; border-radius: 16px;" src="https://image.shutterstock.com/image-photo/colleagues-working-on-agile-product-260nw-1376317913.jpg">-->
    <!--    <iframe style="max-width: 90vw; max-height: calc(90vw * 315 / 560)" src="https://www.youtube.com/embed/QH2-TGUlwu4" width="560" height="315" frameborder="0"></iframe>-->
  </div>
</div>

